// Single source of truth for the ?character=<slug> deep-link.
//
// characterState's resolveId() gives this URL param PRIORITY over the
// localStorage selection (so a shared/deep link always wins on first load).
// The consequence: an in-place character switch — which writes localStorage via
// setCurrentCharacterId — must also reconcile the URL, or a stale
// ?character=<old> silently overrides the user's new choice on every
// re-resolution. That pinned the app to a rigless character with no escape:
// the error overlay's "switch to another character" buttons set localStorage,
// but AvatarModel.loadAll() re-resolved the old slug from the URL and failed
// forever. See src/lib/characterState.js (resolveId / setCurrentCharacterId).

const PARAM = 'character'

// Rewrite an EXISTING ?character= param to `id` so the URL agrees with an
// explicit switch. Returns true when the URL was changed.
//
// Only rewrites a param that is already present: a clean URL is driven by
// localStorage, and a switch should not start pinning a slug into a
// previously-clean URL (that would make the address bar sticky across reloads
// in a way the user never opted into). Uses history.replaceState so the switch
// doesn't push a history entry or trigger a navigation/reload.
export function reconcileCharacterUrlParam(id, win = (typeof window !== 'undefined' ? window : undefined)) {
  if (!id) return false
  if (!win?.location?.href || typeof win.history?.replaceState !== 'function') return false
  let url
  try { url = new URL(win.location.href) } catch { return false }
  if (!url.searchParams.has(PARAM)) return false
  if (url.searchParams.get(PARAM) === id) return false
  url.searchParams.set(PARAM, id)
  try {
    win.history.replaceState(win.history.state ?? null, '', url.toString())
  } catch {
    return false
  }
  return true
}
